import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";

const { Body, Caps, PrimarySmall, SecondarySmall } = typography;
const { BRAND, BRAND_DARK, GRAY_LIGHT } = colors;

export const ValuationContent = styled.div`
  margin-top: 10px;
`;

export const ValuationDetails = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  margin-bottom: 14px;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
`;

export const Price = styled(PrimarySmall).attrs({
  as: "strong"
})`
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const LabelText = styled(Body).attrs({
  as: "span"
})`
  line-height: 26px;
`;

export const Label = styled.div`
  margin: 5px 0;
`;

export const Value = styled(SecondarySmall).attrs({
  as: "strong"
})``;

export const Spacer = styled.hr`
  background-color: ${GRAY_LIGHT};
  margin-bottom: 0;
`;

export const TooltipContainer = styled.span`
  display: inline-block;
  margin-left: 5px;
`;

export const TooltipContent = styled.div`
  line-height: 20px;
  padding: 5px;
`;

export const ViewMoreButton = styled(Caps).attrs({
  as: "button"
})`
  color: ${BRAND};
  background: transparent;
  border: none;
  padding: 0;
  &:hover {
    color: ${BRAND_DARK};
  }
  &:active {
    color: ${BRAND};
  }
`;
